module.exports = __webpack_public_path__ + "static/gargoyle-c2eee48126baff580f6810fe9de7d74f.jpg";